import React from "react";
import { useLanguage } from "../../hooks/useLanguage";
import BookingForm from "./BookingForm";
import { motion } from "framer-motion";

export default function BookingSection() {
  const { t } = useLanguage();

  return (
    <section
      id="book"
      className="py-24 bg-gradient-to-b from-white to-gray-50 dark:from-gray-800 dark:to-gray-900"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <h2 className="text-5xl font-extrabold text-center mb-4 gradient-text">
            {t("booking.title")}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mb-12 rounded-full"></div>

          <div className="glass-card p-8 md:p-10 rounded-2xl shadow-xl backdrop-blur-sm">
            <BookingForm />
          </div>
        </motion.div>
      </div>
    </section>
  );
}